import { learningObjectivesIntro, activitiesListIntro, standardActivities, standardActivitiesClosing, estimated, closing } from './AL00000Sprint00'
import { getModuleDescriptionByClassSectionID } from '../DataAndAPIs/ClassSections'

import { finalProjectProposalLink } from '../Activities/FinalProjectProposal'
import { chapter22Lecture, chapter26Lecture } from '../ActivityVideo/ActivityArchitecture'
import { architectureDesignLewisPhase2Link } from '../Activities/ArchitectureDesignLewis'
import { oreillyPlaylistSA } from '../DataAndAPIs/Links'
import { initialPost } from './AL00000Sprint00'

export const al61200Sprint06 = (classSectionID, sprint) => {
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescriptionByClassSectionID(classSectionID, sprint-1)}</h5>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Successfully enhance and document software architecture</li>
			<li>Understand the Management and Governance of software architecture</li>
			<li>Understand the Architectures for the Cloud</li>
			<li>Implement the server-side storage for service-oriented architecture</li>
		</ul>

		{list61200Sprint06(sprint)}
		{closing(sprint)}
	</div> )
}

export const list61200Sprint06 = (sprint) => {
	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, architectureDesignLewisPhase2Link(), oreillyPlaylistSA(), false)}
			<li>Review and update your team’s {finalProjectProposalLink()}</li>
			<li>Read “Software Architecture in Practice (SAP) - Chapter 22: Management and Governance” and watch the associated {chapter22Lecture()}</li>
			{initialPost(sprint)}
			<li>Read “SAP - Chapter 26: Architectures for the Cloud” and watch the associated {chapter26Lecture()}</li>
			{standardActivitiesClosing(sprint, architectureDesignLewisPhase2Link(), estimated('8 hours'))}
		</ol>
	</div> )
}
